<div class="h-100 d-flex flex-column">
  <app-title></app-title>

  <div class="flex-grow-1" style="overflow: auto;">
    <app-column-list
      class="h-100"
      [objects$]="sites$"
      [textProperty]="properyToDisplay"
      (clickObject)="onClickHospital($event)"
    ></app-column-list>
  </div>
  <div class="row mt-3">
    <div class="col">
      <app-btn
        [dataTxt]="'BACK'"
        (callback)="onClickRetour()"
        [icon]="'chevron-left'"
        [iconLocation]="'left'"
      ></app-btn>
    </div>
  </div>
</div>